module.exports = "https://cdn.dove.it/_next/static/public/assets/agents/graziani-become-agent.50448c0bac4028ef9dd063472a76f8e3.jpg";